import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Error404PageComponent } from './error404-page/error404-page.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Full Calendar
import { FullCalendarModule } from '@fullcalendar/angular';

// reCAPTCHA
import { RecaptchaModule } from "ng-recaptcha";

import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { ToolbarModule } from 'primeng/toolbar';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { TableModule } from 'primeng/table';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { PanelModule } from 'primeng/panel';
import { FieldsetModule } from 'primeng/fieldset';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { ImageModule } from 'primeng/image';
import { TabViewModule } from 'primeng/tabview';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputMaskModule } from 'primeng/inputmask';
import { DropdowInstitutionsComponent } from './components/dropdow-institutions/dropdow-institutions.component';
import { RatingModule } from 'primeng/rating';
import { AccordionModule } from 'primeng/accordion';
import { ChipsModule } from 'primeng/chips';
import { ChipModule } from 'primeng/chip';
import { DropdownEmailsComponent } from './components/dropdown-emails/dropdown-emails.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownRolesComponent } from './components/dropdown-roles/dropdown-roles.component';
import { InplaceModule } from 'primeng/inplace';

@NgModule({
  providers: [
    MessageService,
    ConfirmationService,
  ],
  declarations: [
    Error404PageComponent,
    DropdowInstitutionsComponent,
    DropdownEmailsComponent,
    DropdownRolesComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    ButtonModule,
    FormsModule,
    RecaptchaModule,
    DropdownModule,
  ],
  exports: [
    Error404PageComponent,
    HttpClientModule,

    //For reactive forms
    ReactiveFormsModule,
    FormsModule,

    //Prime NG modules

    InputTextModule,
    ButtonModule,
    CheckboxModule,
    PasswordModule,
    AutoCompleteModule,
    DropdownModule,
    DividerModule,
    ToolbarModule,
    MenuModule,
    MenubarModule,
    TableModule,
    PanelMenuModule,
    ToastModule,
    InputNumberModule,
    CalendarModule,
    CardModule,
    DialogModule,
    PanelModule,
    FieldsetModule,
    MultiSelectModule,
    ConfirmPopupModule,
    InputSwitchModule,
    FileUploadModule,
    ConfirmDialogModule,
    TagModule,
    ImageModule,
    TabViewModule,
    InputTextareaModule,
    RadioButtonModule,
    RatingModule,
    AccordionModule,
    ChipsModule,
    ChipModule,
    ProgressSpinnerModule,
    InplaceModule,
    //Modules for the calendar

    FullCalendarModule,
    RecaptchaModule,

    //FORMAT PHONE NUMBER FIELD
    InputMaskModule,

    DropdowInstitutionsComponent,
    DropdownEmailsComponent,
    DropdownRolesComponent,
  ],
})
export class SharedModule {}
